import React from 'react'
import {NotFoundBoundary, useLoadingRoute} from 'react-navi'
import TopNav from "./TopNav";
import Loading from "./Loading";
import styled from 'styled-components';
import config from "../config";
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const LayoutStyled = styled.div`
    background: url("${config.baseV1Url}/img/header_bg.jpeg") repeat-x fixed 0 0,
    url("${config.baseV1Url}/img/paper.jpg") repeat-x fixed 0 11px,
    url("${config.baseV1Url}/img/rust_top.jpg") repeat-x fixed 0 47px
    ;
    font-family: 'Source Sans Pro', sans-serif;
    //tr:nth-child(even) {background: #CCC}
    tr:nth-child(odd) {background: #f7f4ed}
`;
const MainStyled = styled.main`
  background-color: #fff;
  padding-top: 15px;
`;
const HeaderStyled = styled.header`
  height: ${({mobile}) => mobile ? 70 : 150}px;
  width: 100%;
  margin: 0 auto;
`;
export default function Layout({ children, isAuthenticationStateKnown, currentUser }) {
    let loadingRoute = useLoadingRoute();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <LayoutStyled>
            {/* This component shows a loading indicator after a delay */}
            <Loading isBusy={!!loadingRoute} delayMs={200} />
            <HeaderStyled mobile={!matches}>
                <TopNav {...{isAuthenticationStateKnown, currentUser, mobile: !matches}}/>
            </HeaderStyled>
            <MainStyled>
                <NotFoundBoundary render={renderNotFound}>
                    {children}
                </NotFoundBoundary>
            </MainStyled>
        </LayoutStyled>
    )
}
const renderNotFound = () => {
    return (
        <div className='Layout-error'>
            <h1>404 - Not Found</h1>
        </div>
    )
}